import { Box, Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Radio, MenuItem, InputLabel, FormControl, Typography, Popover} from "@mui/material";
import { useMemo, useState, useRef } from "react";
import { useComparisonChartDetails, useReportDetails } from "../../layouts/report/ReportDetailsContext";
import { isMobileView } from "../../utils/Reusables";
//import Select from '@mui/material/Select';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg";

export function ComparisonChartSideComponent() {
  const { reportDetails } = useReportDetails();
  const { selectedMeasures, selectedDimension, setSelectedMeasures, setSelectedDimension, measures, dimensions } = useComparisonChartDetails();
  
  const [compareByVal, setCompareByVal] = useState(null);
  const [compareBySelectStatus, setComparBySelectStatus] = useState(false);
  const [compareByFilterInputEl, setCompareByFilterInputEl] = useState(null);
  const [selectCompareByFilterWidth, setSelectCompareByFilterWidth] = useState('200px');
  const compareByFilterInputId = compareByVal ? 'simple-popover' : undefined;
  const selectCompareByRef = useRef(null);

  const [compareOfVal, SetCompareOfVal] = useState(null);
  const [compareOfSelectStatus, setComparOfSelectStatus] = useState(false);
  const [compareOfFilterInputEl, setCompareOfFilterInputEl] = useState(null);
  const [selectCompareOfFilterWidth, setSelectCompareOfFilterWidth] = useState('200px');
  const compareOfFilterInputId = compareByVal ? 'simple-popover' : undefined;
  const selectCompareOfRef = useRef(null);

  if (!reportDetails?.comparisonChartType) return null


  function handleSelectMeasure(measure) {
    if (measure.fieldName === selectedMeasures?.fieldName) return;
    setSelectedMeasures({ ...measure });
  }
  function handleSelectDimention(dimention) {
    if (dimention.fieldName === selectedDimension?.fieldName) return;
    setSelectedDimension({ ...dimention });
  }

  const handleMobileSelectDimention = (dim) => {
    setComparBySelectStatus(false)
    //console.log(dim, compareByVal)
    if (dim === compareByVal) return;
    setCompareByVal(dim)
    setSelectedDimension({ ...dim });

    setCompareByFilterInputEl(null);
  }

  const handleCompareBySelectClick = (event) => {
    setComparBySelectStatus(true)
    setSelectCompareByFilterWidth(selectCompareByRef.current.clientWidth);
    if (event.currentTarget != compareByFilterInputEl) {
        setCompareByFilterInputEl(event.currentTarget);
    }
  };

  const handleMobileMeasureDimention = (mea) => {
    setComparOfSelectStatus(false)
   // console.log(dim, compareByVal)
    if (mea === compareOfVal) return;
    SetCompareOfVal(mea)
    setSelectedMeasures({ ...mea });

    setCompareOfFilterInputEl(null);
  }

  const handleCompareOfSelectClick = (event) => {
    setComparOfSelectStatus(true)
    setSelectCompareOfFilterWidth(selectCompareByRef.current.clientWidth);
    if (event.currentTarget != compareOfFilterInputEl) {
        setCompareOfFilterInputEl(event.currentTarget);
    }
  };


  return (
    <>
   { (window.innerWidth > 1023) ?
      <Box className="CompareBy-reports ">
        <h3 className="CompareBy-reports-title">Compare By</h3>
        <List>
          {
            dimensions.map((dimention, index) => <DimentionItem key={`dimention${index}`} dimention={dimention} selectedDimension={selectedDimension} handleSelectDimention={handleSelectDimention} />)
          }
        </List>
        <Box>
          <h3 className="Comparision-reports-title">Comparison of</h3>
          <List>
            {
              measures.map((measure, index) => <MeasureItem key={`measure${index}`} measure={measure} selectedMeasures={selectedMeasures} handleSelectMeasure={handleSelectMeasure} />)
            }
          </List>
        </Box>
      </Box>
   :
   <Box className="CompareBy-reports-mweb comparison-report-mobile">
    
      <Box className="re-custom-select-wrapper" ref={selectCompareByRef}>
        <Box className='re-custom-select re-custom-select-filter' onClick={handleCompareBySelectClick}  >
          <Box className='re-custom-select-placeholder'>{compareByVal ? (compareByVal?.displayName ?? compareByVal?.title) : 'Compare By'}</Box>
          <DropDownIcon className={`re-custom-select-icon ` + (compareBySelectStatus ? `open` : ``)} />
        </Box>
        
      </Box>
      <Popover
        open={compareBySelectStatus}
        id={compareByFilterInputId}
        anchorEl={compareByFilterInputEl}
        onClose={() => setComparBySelectStatus(compareBySelectStatus ? false : true)}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        PaperProps={{
            classes: {
                root: 're-custom-select-dropdown'
            }
        }}
      >
        <Box className={`re-custom-select-options ` + (compareBySelectStatus ? `show` : ``)} sx={{ width: selectCompareByFilterWidth }}>
          {
            dimensions.map((dimension, index) => <MeasureMobileItem key={`dimension${index}`} measure={dimension} handleSelectClick={handleMobileSelectDimention}/>)
          }
        </Box>
      </Popover>


      <Box className="re-custom-select-wrapper" ref={selectCompareOfRef}>
        <Box className='re-custom-select' onClick={handleCompareOfSelectClick}  >
          <Box className='re-custom-select-placeholder'>{compareOfVal ? compareOfVal?.displayName : 'Comparison Of'}</Box>
          <DropDownIcon className={`re-custom-select-icon ` + (compareOfSelectStatus ? `open` : ``)} />
        </Box>
      </Box>
      <Popover
        open={compareOfSelectStatus}
        id={compareOfFilterInputId}
        anchorEl={compareOfFilterInputEl}
        onClose={() => setComparOfSelectStatus(compareOfSelectStatus ? false : true)}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        PaperProps={{
            classes: {
                root: 're-custom-select-dropdown'
            }
        }}
      >
        <Box className={`re-custom-select-options ` + (compareOfSelectStatus ? `show` : ``)} sx={{ width: selectCompareOfFilterWidth }}>
          {
            measures.map((measure, index) => <MeasureMobileItem key={`dimention${index}`} measure={measure} handleSelectClick={handleMobileMeasureDimention} />)
          }
        </Box>

      </Popover>

           
    </Box>
    
    
  }
    </>
   
  )
}

function MeasureItem({ index, measure, selectedMeasures, handleSelectMeasure }) {
  const text = useMemo(() => measure.title || measure.displayName || measure?.fieldName?.split('.')?.[1], [measure?.fieldName]);
  if (!measure || !text) return null;
  return (
    <ListItem
      disablePadding
      key={measure.fieldName}
      onClick={() => handleSelectMeasure(measure)}
    >
      <ListItemButton
        selected={measure.fieldName === selectedMeasures?.fieldName}
      >
        <ListItemIcon>
          <Radio
            checked={measure.fieldName === selectedMeasures?.fieldName}
            value={measure.fieldName}
            name="measure"
            inputProps={{ 'aria-label': 'measure' }}
          />
        </ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  )
}
function DimentionItem({ index, dimention, selectedDimension, handleSelectDimention }) {
  const text = useMemo(() => dimention.title || dimention.displayName || dimention?.fieldName?.split('.')?.[1], [dimention?.fieldName]);
  if (!dimention || !text) return null;
  return (
    <ListItem
      disablePadding
      key={dimention.fieldName}
      onClick={() => handleSelectDimention(dimention)}
    >
      <ListItemButton
        selected={dimention.fieldName === selectedDimension?.fieldName}
      >
        <ListItemIcon>
          <Radio
            checked={dimention.fieldName === selectedDimension?.fieldName}
            value={dimention.fieldName}
            name="dimention"
            inputProps={{ 'aria-label': 'dimention' }}
          />
        </ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  )
}

function MeasureMobileItem({ measure, handleSelectClick }) {
  const text = useMemo(() => measure?.title || measure?.displayName || measure?.fieldName?.split('.')?.[1], [measure?.fieldName]);
  if (!measure || !text) return null;
  return (
    <Box className="re-custom-select-option"
      key={measure.fieldName}
      onClick={() => handleSelectClick(measure)}
    >
      {text}
    </Box>
  )
}